import React, { useEffect, useState } from 'react';
import { Snackbar, SnackbarContent } from '@material-ui/core';
import ReactDOM from 'react-dom';
import warning from "assets/Warning.svg"

const iconSvgs = {
 
  error: warning ,
};

const getBackgroundColor = (severity) => {
  switch (severity) {
   
    case 'error':
      return '#d32f2f';
    default:
      return '#fff';
  }
};


let toastState = {
  isOpen: false,
  message: '',
  severity: 'error',
  duration: 3000,
};


let toastListeners = [];


const notifyListeners = () => {
  toastListeners.forEach(listener => listener({ ...toastState }));
};

export const showToast = (message, severity = 'error', duration = 4000) => {
  toastState = {
    isOpen: true,
    message,
    severity,
    duration,
  };
  notifyListeners();
};


export const hideToast = () => {
  toastState.isOpen = false;
  notifyListeners();
};


function ToastWrapper(props) {
  const { message, onClose, severity } = props;

  return (
    <SnackbarContent
      style={{
        backgroundColor: getBackgroundColor(severity),
        color: '#fff',
        fontSize: '13px',
        padding: '8px 12px',
        minHeight: 'auto',
      }}
      message={
        <span
          id="portal-toast-message"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '13px',
            lineHeight: '1.2',
          }}
        >
         
          <img
            src={iconSvgs[severity]}
            alt={severity}
            style={{
              width: '20px',
              height: '20px',
              flexShrink: 0,
              color:"#fff"
            }}
          />
          {message}
        </span>
      }
      action={[
        <button
          key="close"
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            color: 'inherit',
            cursor: 'pointer',
            fontSize: '16px',
            padding: '0 4px',
            marginLeft: '8px',
            marginRight:"8px"
          }}
        >
          ✕
        </button>,
      ]}
    />
  );
}


export const ToastPortal = () => {
  const [toast, setToast] = useState(toastState);

  useEffect(() => {
 
    const unsubscribe = (newState) => {
      setToast(newState);
    };

    toastListeners.push(unsubscribe);

    return () => {
      toastListeners = toastListeners.filter(listener => listener !== unsubscribe);
    };
  }, []);

  const handleClose = () => {
    hideToast();
  };


  return ReactDOM.createPortal(
    <Snackbar
      open={toast.isOpen}
      autoHideDuration={toast.duration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <ToastWrapper
        onClose={handleClose}
        severity={toast.severity}
        message={toast.message}
      />
    </Snackbar>,
    document.body
  );
};
